// extracted by mini-css-extract-plugin
export default {"newFooter":"ZA91jquzE6WjeEJOevqy","copyright":"eBvk5GOt9JtKswNVPzYQ"};